import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getAllWithdrawRequestStart } from '../../../store/redux-slices/tenantUsers'
import { getDateDaysAgo, formatDateYMD } from '../../../utils/dateFormatter'
import useDidMountEffect from '../../../utils/useDidMountEffect'

const useWithdrawRequestList = ({ type }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [name, setName] = useState('')
  const [status, setStatus] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(10),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const [paymentProvider, setPaymentProvider] = useState('')
  const { withdrawRequests, loading } = useSelector((state) => state.tenantUsers)
  const isInitialRender = useDidMountEffect()
  const totalPages = Math.ceil(withdrawRequests?.count / limit)
  const isSuperAdmin = location.pathname.includes('super-admin')

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(getAllWithdrawRequestStart({
            type,
            limit,
            page,
            name: name.replace('+', '%2B'),
            status,
            startDate: formatDateYMD(state.map(a => a.startDate)),
            endDate: formatDateYMD(state.map(a => a.endDate)),
            paymentProvider,
            tenantId: selectedPortal,
            adminId: selectedClient
          }))
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [name, paymentProvider])

  useEffect(() => {
    setPage(1)
    dispatch(getAllWithdrawRequestStart({
      type,
      limit,
      page,
      name: name.replace('+', '%2B'),
      status,
      startDate: formatDateYMD(state.map(a => a.startDate)),
      endDate: formatDateYMD(state.map(a => a.endDate)),
      paymentProvider,
      tenantId: selectedPortal,
      adminId: selectedClient
    }))
  }, [limit, status, state, selectedClient, selectedPortal])

  useEffect(() => {
    !isInitialRender && dispatch(getAllWithdrawRequestStart({
      type,
      limit,
      page,
      name: name.replace('+', '%2B'),
      status,
      startDate: formatDateYMD(state.map(a => a.startDate)),
      endDate: formatDateYMD(state.map(a => a.endDate)),
      paymentProvider,
      tenantId: selectedPortal,
      adminId: selectedClient
    }))
  }, [page])

  const resetFilter = () => {
    setLimit(15)
    setPage(1)
    setName('')
    setStatus('')
    setPaymentProvider('')
    setSelectedPortal('')
    setSelectedClient('')
    setState([
      {
        startDate: getDateDaysAgo(10),
        endDate: new Date(),
        key: 'selection'
      }
    ])
  }

  const getStatus = (status) => {
    switch (status) {
      case 0:
        return 'Pending'

      case 5:
        return 'Approved'

      case 2:
        return 'Cancelled'
    }
  }

  return {
    limit,
    page,
    name,
    status,
    state,
    paymentProvider,
    withdrawRequests,
    setLimit,
    setPage,
    setName,
    setStatus,
    setState,
    setPaymentProvider,
    loading,
    totalPages,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    selectedClient,
    resetFilter,
    getStatus,
    isSuperAdmin
  }
}

export default useWithdrawRequestList
